export const ERROR_CODE = {
  SUCCESS: 0,
  ERROR: -1,
  ILLEGAL_ARGUMENT: 400,
  TOKEN_EMPTY: 4000,
  NEED_LOGIN: 4001,
  NO_PERMISSION: 4003,
  /** 画师资格缺失或已失效（工作台用） */
  PAINTER_INVALID: 4005,
  HAS_UNRECEIVED_SENDS: 4014,
} as const;
